import script from "./ProductCreateView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCreateView.vue?vue&type=script&setup=true&lang=js"

import "./ProductCreateView.vue?vue&type=style&index=0&id=49e44d15&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e44d15"]])

export default __exports__